import React, { useEffect, useState } from 'react';
import api from '../api';
import Table from './ui/Table';
import Card from './layout/Card';
import SectionHeader from './layout/SectionHeader';

export default function UsersSection({ token, setError }) {
  const [users, setUsers] = useState(null);

  useEffect(() => {
    if (!token) return;
    const fetch = async () => {
      try {
        const res = await api.get('/admin/users', {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUsers(res.data.users);
      } catch (err) {
        setError(err.response?.data?.error || 'Failed to fetch users');
      }
    };
    fetch();
  }, [token]);

  if (!users) return null;

  const columns = [
    { key: 'id', title: 'ID' },
    { key: 'name', title: 'Name' },
    { key: 'email', title: 'Email' },
    { key: 'role', title: 'Role' },
  ];

  return (
    <div className="space-y-4">
      <SectionHeader title="Users" />
      <Card>
        <Table columns={columns} data={users} />
      </Card>
    </div>
  );
}
